import React from 'react';
import { ArrowRightIcon, TagIcon } from 'lucide-react';
interface CTAButtonProps {
  productName?: string;
  regularPrice?: string;
  salePrice?: string;
  discount?: string;
  url?: string;
  trackingName?: string;
}
const CTAButton: React.FC<CTAButtonProps> = ({
  productName = 'Maas & Bath - Ergo Z Pillow',
  regularPrice = '$139.98',
  salePrice = '$69.99',
  discount = '$70 OFF',
  url = 'https://offer.maasbath.com/maasbath/pillow/en/us/v5cro1/checkout.html?uid=593&oidsm=157&affidsm=39&sub1=877&uid=2665&oid=759&affid=877',
  trackingName = 'Maas & Bath Ergo Z Pillow'
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Facebook Pixel tracking (fire-and-forget)
    setTimeout(() => {
      try {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Advertorial_ClickToOffer', {
            content_name: trackingName,
            content_category: 'Health',
            value: parseFloat(salePrice.replace(/[^\d.]/g, ''))
          });
        }
      } catch (error) {
        console.error('Facebook Pixel tracking error:', error);
      }
    }, 0);
  };
  return <div className="w-full max-w-md mx-auto border border-gray-300 rounded-lg p-4 bg-white" data-id="element-3315">
      <div className="flex items-center gap-1.5 mb-2" data-id="element-3316">
        <TagIcon className="h-3.5 w-3.5 text-gray-600" data-id="element-3317" />
        <span className="text-xs font-medium text-gray-600 uppercase tracking-wide" data-id="element-3318">
          READER ACCESS
        </span>
      </div>

      <h3 className="text-base font-serif font-medium text-gray-900 mb-1.5" data-id="element-3319">
        {productName}
      </h3>

      <div className="flex items-center gap-1.5 mb-3" data-id="element-3320">
        <span className="text-sm text-gray-400 line-through" data-id="element-3321">
          {regularPrice}
        </span>
        <span className="text-base font-medium text-green-600" data-id="element-3322">
          {salePrice}
        </span>
        <span className="bg-yellow-100 text-yellow-800 text-xs font-semibold px-2.5 py-1 rounded" data-id="element-3323">
          {discount}
        </span>
      </div>

      <a href={url} onClick={handleClick} target="_blank" rel="noopener noreferrer" className="block w-full bg-gray-900 hover:bg-gray-800 text-white font-medium text-base py-3 px-6 rounded transition-colors duration-200 text-center" data-id="element-3324">
        <span className="flex items-center justify-center gap-2" data-id="element-3325">
          Access Offer
          <ArrowRightIcon className="h-4 w-4" data-id="element-3326" />
        </span>
      </a>
    </div>;
};
export default CTAButton;